export default "__VITE_ASSET__CFsVzIht__"